import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import { useAuthStore } from './stores/auth';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import './assets/styles/design-system.css';
import './assets/styles/global.css';
// 导入 ResizeObserver 错误抑制
import './utils/suppressResizeObserver.js';
const app = createApp(App);
const pinia = createPinia();
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
app.use(pinia);
app.use(router);
app.use(ElementPlus);
// 初始化认证状态
const authStore = useAuthStore();
authStore.checkAuth();
app.mount('#app');
